module.exports = __webpack_public_path__ + "static/media/PDF_111.704b42b4.pdf";